import { useState, useEffect, useRef } from "react";
import NewEventForm from "./NewEventForm";
// import { FaRegHeart, FaHeart } from "react-icons/fa";
import { BsCalendar2Heart, BsCalendar2HeartFill } from "react-icons/bs";
// import {BsCalendar2Plus,BsCalendar2PlusFill  } from "react-icons/bs";
import { LuCalendarPlus, LuCalendarHeart } from "react-icons/lu";

import { PlusIcon, XIcon } from "../Icons/Icons.jsx";
import IconButton from "../ui/Button/IconButton";
import useEventStore from "../../Store/EventStore";
import useFavoriteStore from "../../Store/FavoriteStore.jsx";
import EventDropdown from "./EventDropdown";
import { useTranslation } from "react-i18next";

export default function Component({ giftID, gift_image }) {
  const { t } = useTranslation();
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [eventOpen, setEventOpen] = useState(false);
  const [newEventIsOpen, setNewEventIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  // const [events, setEvents] = useState([]);
  const [position, setPosition] = useState("right-0"); // Initialize position state

  const loggedIn = localStorage.getItem("loggedin") === "true";
  const localEventData = localStorage.getItem("eventData");
  const prompt = localStorage.getItem("prompt");
  const componentRef = useRef(null);
  const openButtonRef = useRef(null);

  const {
    handleFetchEvents,
    events,
    spaces,
    setEvents,
    likeGift,
    addProductToEvent,
    removeProductFromEvent,
  } = useFavoriteStore();

  const { openComponentID, setOpenComponentID } = useEventStore();

  // Re-adjust the placement of the Favorite dropdown
  useEffect(() => {
    const adjustPosition = () => {
      if (componentRef.current) {
        const { right, left, width } =
          componentRef.current.getBoundingClientRect();
        const screenWidth = window.innerWidth;

        if (right > screenWidth) {
          setPosition("right-0");
        } else if (left < 0) {
          setPosition("left-0");
        }
      }
    };

    adjustPosition();
    window.addEventListener("resize", adjustPosition);
    return () => window.removeEventListener("resize", adjustPosition);
  }, [eventOpen]);

  //filtered Data from the events that will be displayed in the dropdown: The Name; The Date
  const filteredEvents =
    events &&
    events.filter(
      (event) =>
        event.eventName &&
        event.eventName.toLowerCase().includes(searchTerm.toLowerCase())
    );

  // Open the dropdown with events.
  const handleOpen = () => {
    if (openComponentID === giftID) {
      setEventOpen(false);
      setOpenComponentID(null);
    } else {
      setOpenComponentID(giftID);
      setEventOpen(true);
      handleFetchEvents();
    }
  };

  return (
    <div className="relative">
      <IconButton
        variant="favorite"
        rounded="full"
        size="iconMd"
        onClick={handleOpen}
        ref={openButtonRef}
        icon={
          selectedEvent !== null ? (
            <LuCalendarHeart className="w-5 h-5 text-red-500 group-hover/button:text-white" />
          ) : (
            <LuCalendarPlus className="w-5 h-5" />
          )
        }
        aria-label={t("career.saveToEventTooltip")}
      />
      {eventOpen && openComponentID === giftID && (
        <EventDropdown
          giftID={giftID}
          events={events}
          spaces={spaces}
          selectedEvent={selectedEvent}
          setSelectedEvent={setSelectedEvent}
          setEventOpen={setEventOpen}
          setOpenComponentID={setOpenComponentID}
          removeProductFromEvent={removeProductFromEvent}
          addProductToEvent={addProductToEvent}
          handleFetchEvents={handleFetchEvents}
          openButtonRef={openButtonRef}
          giftImage={gift_image}
        />
      )}
    </div>
  );
}
